import {
    REQUEST_COLLABORATOR_NETWORK_PROFILE,
    RESPONSE_COLLABORATOR_NETWORK_PROFILE,
    FAILURE_COLLABORATOR_NETWORK_PROFILE,
    GLOBAL_KEYWORD_CHANGE,
    INCREMENT_COLLAB,
  SET_ZERO_COLLAB
} from '../../actions/types';
import { EXPERT_COLLABORATOR_NETWORK_PROFILE_API } from '../../constants/_api';
import query from './query';
import asyncActionErrorHandler from '../../utils/asyncActionErrorHandler';

const dispatchGlobalKeywordChange = (dispatch, payload) => dispatch({
    type: GLOBAL_KEYWORD_CHANGE,
    payload
});

const dispatchRequest = (dispatch, payload) => dispatch({
    type: REQUEST_COLLABORATOR_NETWORK_PROFILE,
    payload
});

const dispatchResponse = (dispatch, payload) => dispatch({
    type: RESPONSE_COLLABORATOR_NETWORK_PROFILE,
    payload
});

const dispatchFailure = (dispatch) => dispatch({
    type: FAILURE_COLLABORATOR_NETWORK_PROFILE
});

export const getCollaboratorNetworkProfile = (keyword, token) => asyncActionErrorHandler(async (dispatch) => {

    if (!keyword) {
        return
    }

    // DISPATCH GLOBAL KEYWORD CHANGE
    dispatchGlobalKeywordChange(dispatch, { keyword });

    dispatchRequest(dispatch, { keyword });

    let url = `${EXPERT_COLLABORATOR_NETWORK_PROFILE_API}?q=${keyword}`;
    let result = await query(url, token);
    result = await result.json();
    result.keyword = keyword;
    result.body.statusCode = result.statusCode;
    
    // if(result){
    //     if (result.statusCode === 200) {
    //       dispatch({
    //         type: SET_ZERO_COLLAB 
    //       });
    //     } else if (result.statusCode === 404) {
    //       dispatch({
    //         type: INCREMENT_COLLAB
    //       });
    //     }
  
    //   }

    if (result.message === 'SUCCESS') {
        dispatchResponse(dispatch, result.body);
    } else {
        dispatchFailure(dispatch);
    }

}, dispatchFailure);